import {
  Squad,
  SquadBuilderMode,
} from "../../../../../redux/squadBuilder/squadBuilderUtils";
import { MetaRatingAndChemistry } from "../../../../molecules/MetaRatingAndChemistry/MetaRatingAndChemistry";
import ChemSummary from "../../../../organisms/SquadBuilder/ChemSummary/ChemSummary";
import { PanelHeader } from "../../RightPanel/PanelHeader/PanelHeader";
import { ComponentContainer } from "../../components/ComponentContainer/ComponentContainer";
import { PanelContainer } from "../../components/PanelContainer/PanelContainer";
import { SquadPrice } from "./SquadPrice/SquadPrice";

type Props = {
  squad: Squad;
  tempSquad: Squad;
  mode: SquadBuilderMode;
};
export const ChemistryOverviewMode = ({ squad, tempSquad, mode }: Props) => {
  const {
    manager: tempManager,
    players: tempPlayers,
    chemistry: tempChemistry,
    metaRating: tempMetaRating,
  } = tempSquad;

  const { chemistry, metaRating, players } = squad;
  const showChemSummary =
    players.find((p) => p?.resourceId) ||
    tempPlayers.find((p) => p?.resourceId) ||
    squad.manager.country ||
    squad.manager.league;

  return (
    <>
      <PanelHeader title="Squad Overview" />
      <PanelContainer>
        <ComponentContainer marginTop="mt-8">
          <MetaRatingAndChemistry
            tempPlayers={tempPlayers}
            tempManager={tempManager}
            chemistry={chemistry}
            metaRating={metaRating}
            tempChemistry={tempChemistry}
            tempMetaRating={tempMetaRating}
          />
        </ComponentContainer>
        <SquadPrice tempSquad={tempSquad} mode={mode} />
        {!!showChemSummary && (
          <ChemSummary
            currentSummary={
              tempMetaRating ? tempChemistry.summary : chemistry.summary
            }
            previousSummary={chemistry.summary}
            playersOutOfPosition={
              tempMetaRating
                ? tempChemistry.playersOutOfPosition
                : chemistry.playersOutOfPosition
            }
          />
        )}
      </PanelContainer>
    </>
  );
};
